import { combineReducers } from 'redux';

import {
  GET_DASHBOARD_ALL_FOLLOWINGS_PENDING,
  GET_DASHBOARD_ALL_FOLLOWINGS_FULFILLED,
  GET_DASHBOARD_ALL_FOLLOWINGS_REJECTED,
} from '../types';

// State interfaces
interface FollowingsState {
  data: any[];
  isFetching: boolean;
  error: string | null;
  message?: string;
}

interface DashboardState {
  followings: FollowingsState;
}

// Action interfaces
interface GetDashboardAllFollowingsPendingAction {
  type: typeof GET_DASHBOARD_ALL_FOLLOWINGS_PENDING;
}

interface GetDashboardAllFollowingsFulfilledAction {
  type: typeof GET_DASHBOARD_ALL_FOLLOWINGS_FULFILLED;
  payload: {
    data: any[];
  };
}

interface GetDashboardAllFollowingsRejectedAction {
  type: typeof GET_DASHBOARD_ALL_FOLLOWINGS_REJECTED;
  payload: {
    message: string;
  };
}

type FollowingsAction = 
  | GetDashboardAllFollowingsPendingAction
  | GetDashboardAllFollowingsFulfilledAction
  | GetDashboardAllFollowingsRejectedAction;

const INITIAL_STATE = {
  FOLLOWINGS: {
    data: [],
    isFetching: false,
    error: null,
  },
};

const followings = (state: FollowingsState = INITIAL_STATE.FOLLOWINGS, action: FollowingsAction): FollowingsState => {
  switch (action.type) {
    case GET_DASHBOARD_ALL_FOLLOWINGS_PENDING:
      return {
        ...state,
        isFetching: true,
      };
    case GET_DASHBOARD_ALL_FOLLOWINGS_FULFILLED: {
      const {
        data,
      } = action.payload;
      return {
        data,
        isFetching: false,
        error: null,
      };
    }
    case GET_DASHBOARD_ALL_FOLLOWINGS_REJECTED: {
      const {
        message,
      } = action.payload;
      return {
        ...state,
        message,
        isFetching: false,
      };
    }
    default:
      return state;
  }
};

export default combineReducers<DashboardState>({
  followings,
});